import { render, staticRenderFns } from "./UltimosVideos.vue?vue&type=template&id=03518363&scoped=true&lang=pug"
import script from "./UltimosVideos.vue?vue&type=script&lang=js"
export * from "./UltimosVideos.vue?vue&type=script&lang=js"
import style0 from "./UltimosVideos.styl?vue&type=style&index=0&id=03518363&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03518363",
  null
  
)

export default component.exports